import { useEffect, useState } from 'react'
import { useSearchParams, Navigate } from 'react-router-dom'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import Breadcrumbs from '../components/Breadcrumbs'

export default function AuthMagic() {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [status, setStatus] = useState<'working' | 'error' | 'done'>('working')
  const [redirectTo, setRedirectTo] = useState<string | null>(null)

  useEffect(() => {
    let mounted = true
    async function run() {
      try {
        if (!token) {
          setStatus('error')
          return
        }
        const r = await axios.post('/api/auth/consume', { token })
        const user = r.data?.user
        if (!mounted) return
        setRedirectTo(user?.isAdmin ? '/admin' : '/portal')
        setStatus('done')
      } catch {
        if (!mounted) return
        setStatus('error')
      }
    }
    run()
    return () => {
      mounted = false
    }
  }, [token])

  if (status === 'done' && redirectTo) return <Navigate to={redirectTo} replace />

  return (
    <div className="min-h-screen pb-24">
      <Breadcrumbs items={[{ key: 'login' }]} />
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        <div className="bg-white dark:bg-slate-800 rounded-2xl p-6 sm:p-8 shadow-xl border border-slate-200 dark:border-slate-700 text-center">
          {status === 'working' ? (
            <>
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                <span className="material-icons">hourglass_top</span>
              </div>
              <p className="font-semibold">{t('auth.processing')}</p>
              <p className="text-sm mt-2 text-slate-600 dark:text-slate-400">{t('auth.processingHint')}</p>
            </>
          ) : (
            <>
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-red-500/10 text-red-600 flex items-center justify-center">
                <span className="material-icons">error</span>
              </div>
              <p className="font-semibold">{t('auth.magicErrorTitle')}</p>
              <p className="text-sm mt-2 text-slate-600 dark:text-slate-400">{t('auth.magicErrorBody')}</p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

